import React, { FC, useState } from 'react';
import { Box, Button, Modal, Typography } from '@material-ui/core';
import { Carousel } from 'react-responsive-carousel';
import { useStyles } from '../../styles';
import placeholder1 from '../../../../../../assets/img/gotmy-placeholder-1.jpeg';

interface Props {
    images: string[];
    isOpen: boolean;
    onClose: () => void;
    onThumbnailPick: (image: string) => void;
}

const ThumbnailPicker: FC<Props> = ({ images, isOpen, onClose, onThumbnailPick }) => {
    const classes = useStyles();

    const [currentCarouselImage, setCurrentCarouselImage] = useState<string>(placeholder1);

    const handleThumbnailPicked = () => {
        onThumbnailPick(currentCarouselImage);
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box className={classes.modal}>
                <Box className={classes.modalHeader}>
                    <Typography className={classes.modalTitle}>Select thumbnails</Typography>
                </Box>

                <Box className={classes.modalContent}>
                    <Box className={classes.imageContainer}>
                        <Carousel
                            showThumbs
                            showArrows
                            showStatus
                            infiniteLoop
                            useKeyboardArrows
                            showIndicators
                            stopOnHover
                            autoPlay={false}
                            onClickThumb={index => {
                                setCurrentCarouselImage(images[index]);
                            }}
                            onClickItem={index => {
                                setCurrentCarouselImage(images[index]);
                            }}
                            onChange={index => {
                                setCurrentCarouselImage(images[index]);
                            }}
                        >
                            {images.map((image, index) => (
                                <div key={index}>
                                    <img src={image} alt="" />
                                </div>
                            ))}
                        </Carousel>

                        <Button className={classes.selectThumbButton} onClick={handleThumbnailPicked}>
                            Use this image
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default ThumbnailPicker;
